import { useState, useEffect } from 'react';
import { useSession } from './Context';
import { useResult, useFind } from '@rails/document/hooks';

import Navbar from '../Navbar';
import UserMenu, { BurgerIcon } from './UserMenu';

import { routes } from '../routes';

const Main = ({ children }) => {
  const {
    document,
    setDocument,
    session: { userId },
  } = useSession();
  const fetcher = useFind(userId, 'users');
  const user = useResult(fetcher);

  useEffect(() => {
    setDocument({ user });
  }, [user, setDocument]);
  const [showUserMenu, setShowUserMenu] = useState(false);
  if (!document?.user) return null;
  return (
    <>
      <nav className='navbar bg-base-100 sticky top-0 z-100 flex shadow-sm'>
        <Navbar routes={routes} />
        <div className='flex flex-grow'></div>
        <div className='flex flex-row items-center'>
          <button onClick={() => setShowUserMenu(true)}>
            <BurgerIcon />
          </button>
        </div>
      </nav>
      <UserMenu
        visible={showUserMenu}
        hideMenu={() => setShowUserMenu(false)}
      />
      <div className='MainContent flex-1 min-h-0 flex flex-col'>{children}</div>
    </>
  );
};

export default Main;
